import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useTranslation } from 'react-i18next';

const navLinkClass = "flex items-center px-3 py-2.5 rounded-xl text-brand-800 hover:bg-brand-50 hover:text-brand-600 transition-colors text-sm font-medium group";

const MainSidebar: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Sidebar>
      <li>
        <Link to="/" className={navLinkClass}>
          <span>{t("programs")}</span>
        </Link>
      </li>
      <li>
        <Link to="/Settings" className={navLinkClass}>
          <span>{t("settings")}</span>
        </Link>
      </li>
    </Sidebar>
  );
};

export default MainSidebar;
